var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrintColoris(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "50mm",
    height: "50mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 5000 5000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .fil4-print {fill:#5B5B5B}\n    .fil5-print {fill:#5FB461}\n    .fil3-print {fill:#1976D2}\n    .fil1-print {fill:#404040}\n    .fil0-print {fill:#606060}\n    .fil2-print {fill:#90CAF9}\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0-print",
    d: "M13.16 2665.56l4973.67 0c0,-746.31 154.17,-1249.23 -621.71,-1249.23l0 -373.01 -264.1 0 0 373.52 -108.92 0 -2984.2 0 -108.93 0 0 -373.52 -264.1 0 0 373.01c-775.88,0 -621.71,502.92 -621.71,1249.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1-print",
    d: "M882.73 4151.85l21.58 -846.29 3212.13 0.13 0.82 846.16c438.72,0 741.7,35.37 846.4,-334.03 64.8,-228.66 23.17,-874.8 23.17,-1152.26l-4973.67 0c0,277.46 -41.63,923.6 23.17,1152.26 104.7,369.4 407.68,334.03 846.4,334.03z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2-print",
    points: "882.73,4151.85 883.66,4897.9 4116.44,4897.9 4117.26,4151.85 4116.44,3305.69 904.31,3305.56 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2-print",
    points: "898.97,1043.32 898.97,1416.84 1007.9,1416.84 3992.1,1416.84 4101.02,1416.84 4101.02,1043.32 4118.11,172.92 883.55,172.92 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3-print",
    points: "1505.27,4027.52 3619.07,4027.52 3619.07,3778.82 1505.27,3778.82 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil3-print",
    points: "1505.27,4524.88 3121.71,4524.88 3121.71,4276.2 1505.27,4276.2 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4-print",
    d: "M898.97 1416.84l0 -373.52 -264.1 0 0 373.01c118.34,12.59 167.88,10.95 264.1,0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil5-print",
    d: "M4590.71 1613.75c60.1,0 108.81,41.75 108.81,93.26 0,51.51 -48.71,93.26 -108.81,93.26 -60.09,0 -108.8,-41.75 -108.8,-93.26 0,-51.51 48.71,-93.26 108.8,-93.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4-print",
    d: "M4365.12 1416.33l0 -373.01 -264.1 0 0 373.52c153.12,6.97 164.16,8.59 264.1,-0.51z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintColoris);
export default __webpack_public_path__ + "static/media/print-coloris.8db51640db5297ef538c2a8bf8a6c550.svg";
export { ForwardRef as ReactComponent };